module.exports = __webpack_public_path__ + "img/Olympic_Museoi.87881660.jpg";